module.exports = __webpack_public_path__ + "a34c6ce70350f5227596f4d4e1fd7034.pdf";